import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Cropper, FixedCropper, ImageRestriction } from "react-advanced-cropper";
import { getZoomFactor } from "advanced-cropper/extensions/absolute-zoom";
import locale from "locale";

import './style.scss';

const RANGE_MIN = 0;
const RANGE_MAX = 1;
const RANGE_STEP = 0.02;

const ImageCropper = ({
    isLarge,
    isModalVisible,
    imageUrl,
    fixtedCropper,
    cropperWidth,
    cropperHeight,
    onSave,
    onClose,
    fileType,
}) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [zoomValue, setZoomValue] = useState(RANGE_MIN);
    const cropperRef = useRef(null);
    const rangeRef = useRef(null);

    useEffect(() => {
        !!imageUrl && setImageSrc(imageUrl);
    }, [imageUrl]);

    const handleSave = () => {
        const cropper = cropperRef.current;
        onSave(cropper.getCanvas().toDataURL(fileType));
    };

    const handleChangeRange = (value) => {
        const cropper = cropperRef.current;

        if (!cropper) return;

        const state = cropper.getState();
        const settings = cropper.getSettings();

        cropper.zoomImage(getZoomFactor(state, settings, value), {});
        setZoomValue(value);

        const progress = Math.round((value / RANGE_MAX) * 100);
        rangeRef.current.style.background = `linear-gradient(to right, #FF434C ${progress}%, #6E6E6E ${progress}%)`;
    };

    const handleClose = () => {
        setImageSrc(null);
        onClose();
    };

    return (
        <Modal
            show={isModalVisible}
            onHide={handleClose}
            className="cp-upload-photo"
            backdrop="static"
            bsSize={isLarge ? "large" : "small"}
        >
            <Modal.Header>
                <Modal.Title>Добавить изображение</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    fixtedCropper
                        ? <>
                            <FixedCropper
                                ref={cropperRef}
                                src={imageSrc}
                                stencilSize={{
                                    width: cropperWidth,
                                    height: cropperHeight,
                                }}
                                stencilProps={{
                                    movable: false,
                                    resizable: false,
                                    handlers: {},
                                    lines: {},
                                }}
                                imageRestriction={ImageRestriction.stencil}
                                backgroundWrapperProps={{
                                    scaleImage: false,
                                }}
                            />
                            <div className="cp-upload-photo__range-container">
                                <span
                                    className="cp-upload-photo__range-button plus"
                                    onClick={() => handleChangeRange(+zoomValue + RANGE_STEP)}
                                />
                                <input
                                    ref={rangeRef}
                                    type="range"
                                    value={zoomValue}
                                    step={RANGE_STEP}
                                    min={RANGE_MIN}
                                    max={RANGE_MAX}
                                    className="cp-upload-photo__range-input"
                                    onChange={(e) => handleChangeRange(e.target.value)}
                                />
                                <span
                                    className="cp-upload-photo__range-button minus"
                                    onClick={() => handleChangeRange(+zoomValue - RANGE_STEP)}
                                />
                            </div>
                        </>
                        : <Cropper
                            ref={cropperRef}
                            src={imageSrc}
                        />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose}>
                    {locale('email.close')}
                </Button>
                <Button onClick={handleSave}>
                    {locale('email.save')}
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

export default ImageCropper;
